
import React from 'react';
import { cn } from '@/lib/utils';
import { useIsMobile } from '@/hooks/use-mobile';
import { scheduleHeaderHeigth, scheduleHeaderHeigthMobile, scheduleSlotsHeigth, getScheduleSlotsHeightMobile, ProcessedSlot, getWeeklySlotHeight, getWeeklyHeaderHeight } from '@/utils/scheduleUtils';

interface WeeklyTimeSlotColumnProps {
  processedSlots: ProcessedSlot[];
  slotDuration: number;
  compact?: boolean;
}

const GAP_HEIGHT = 30; // Hauteur fixe pour les indicateurs de gap

export const WeeklyTimeSlotColumn: React.FC<WeeklyTimeSlotColumnProps> = ({ processedSlots, slotDuration, compact = false }) => {
  const isMobile = useIsMobile();
  const slotHeight = getWeeklySlotHeight(isMobile, compact, slotDuration);
            
  
  return (
    <div className="flex flex-col">
      {/* Header cell to align with day headers */}
      <div className={cn(
        "border-b flex items-center justify-center",
        "border-border bg-card",
        isMobile ? "w-[26px]" : "w-[55px]"
      )}
       style={{ height: getWeeklyHeaderHeight(isMobile, compact) }}
>
        <span className={cn(
          "font-medium text-muted-foreground", 
          isMobile ? "text-[7px]" : "text-xs"
        )}>
          {isMobile ? "H" : "Time"}
        </span>
      </div>
      
      {/* Time slots and gaps */}
      {processedSlots.map((slot, idx) => {
        if (slot.type === 'gap') {
          // Rendu du gap grisé avec plage horaire
          return (
            <div
              key={`gap-${slot.startTime}-${idx}`}
              className={cn(
                "border-b flex items-center justify-center",
                "border-border/50 bg-muted/20",
                isMobile ? "w-[26px] px-0" : "w-[55px] px-1"
              )}
              style={{ height: GAP_HEIGHT }}
            >
              {isMobile ? (
                <span className={cn(
                  "text-[6px] font-medium text-muted-foreground/50"
                )}>
                  ···
                </span>
              ) : (
                <span className={cn(
                  "whitespace-nowrap text-[8px] font-medium text-muted-foreground/60"
                )}>
                  {slot.startTime.substring(0, 5)}
                </span>
              )}
            </div>
          );
        }

        // Rendu normal du créneau horaire
        const timeSlot = slot.time;
        return (
          <div
            key={`slot-${timeSlot}-${idx}`}
            className={cn(
              "border-b flex items-center justify-center",
              "border-border/50 bg-card",
              isMobile ? "w-[26px] px-0" : "w-[55px] px-1"
            )}
             style={{ height: slotHeight }}
            
          >
            {isMobile ? (
              <div className="flex flex-col items-center justify-center leading-none">
                <span className={cn(
                  "text-[8px] font-bold text-muted-foreground"
                )}>
                  {timeSlot.substring(0, 2)}
                </span>
                <span className={cn(
                  "text-[8px] font-bold text-muted-foreground/70"
                )}>
                  {timeSlot.substring(3, 5)}
                </span>
              </div>
            ) : (
              <span className={cn(
                "text-[10px] font-medium leading-none text-muted-foreground"
              )}>
                {timeSlot}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
};
